
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-dnd-demo-plugin-dnd"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.en.md?type=demo')
};